import React from "react";
import ItineraryHubPage from "@/components/ItineraryHubPage";
import { HUB_ATLAS_DESIERTO_FEZ } from "@/lib/itineraryHubs";

export default function AtlasDesiertoFezHubPage() {
  return <ItineraryHubPage hub={HUB_ATLAS_DESIERTO_FEZ} />;
}
